import React, { useState, useEffect } from 'react';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Button } from 'react-bootstrap';
import { BsCheck, BsWrench, BsX } from 'react-icons/bs';
import ProductStockModal from '../modal/ProductStockModal';
import ImprovementActionWindowModal from '../modal/ImprovementActionWindowModal'
import MachineSetupModal from '../modal/MachineSetupModal'
import MaintenancescheduleModal from '../modal/MaintenancescheduleModal';
import IndividualMachineStatusModal from '../modal/IndividualMachineStatusModal'
import MachineMaintenanceModal from '../modal/MachineMaintenanceModal';
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import Loader from '../loader/Loader';
import { formatDate } from "../../utils/formatDate"
const getStatusBadge = (status) => {
  const statusMap = {
    "Operational": { bg: "success-subtle", text: "text-success" },
    "Under Maintenance": { bg: "danger-subtle", text: "text-danger" },
    "Requires Maintenance": { bg: "danger-subtle", text: "text-danger" }
  };
  const { bg, text } = statusMap[status] || { bg: "success-subtle text-succes", text: "text-secondary" };
  return (
    <span className={`badge bg-${bg} ${text} p-2`}>{status}</span>
  );
};
export default function ResourceManagement() {
  const MySwal = withReactContent(Swal);
  const [machineMaintenance, setMachineMaintenance] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [show, setShow] = useState(false);
  const [productStock, setProductStock] = useState(false)
  const [improvementActionWindow, setImprovementActionWindow] = useState(false)
  const [machineSetup, setMachineSetup] = useState(false)
  const [loading, setLoading] = useState(false);
  const [productId, setProductId] = useState(null)
  const [selectedMaintenanceId, setSelectedMaintenanceId] = useState(null);
  const [machineallocation, setMachineallocation] = useState([])
  const [allocations, setAllocations] = useState([]);
  const [productstock, setProductstock] = useState([])
  const [maintenancescheduleList, setMaintenancescheduleList] = useState([])
  const [materialData, setMaterialData] = useState([])
  const [machineSetupId, setMachineSetupId] = useState(null);
  useEffect(() => {
    fetchMachineallocation()
    fetchProductstock()
    fetchMaintenanceschedule()
    fetchMaterialStatusList()
  }, []);

  const fetchMachineallocation = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/manager/machineallocation`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data?.success) {
        setMachineallocation(response?.data || []);
      } else {
        setMachineallocation([]);
      }
    } catch (err) {
      console.error("Error fetchMachineallocation", err.message);
    } finally {
      setLoading(false);
    }
  };
  
  const fetchProductstock = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/manager/productstock`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data?.success) {
        setProductstock(response?.data || []);
      } else {
        setProductstock([]);
      }
    } catch (err) {
      console.error("Error fetchProductstock", err.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchMaintenanceschedule = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/manager/maintenanceschedule`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data?.success) {
        setMaintenancescheduleList(response?.data || []);
      } else {
        setMaintenancescheduleList([]);
      }
    } catch (err) {
      console.error("Error fetchMaintenanceschedule", err.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchMaterialStatusList = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true)
      const response = await axios.get(`${config.API}/manager/floorstock`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data?.success) {
        setMaterialData(response?.data?.floorstock || []);
      } else {
        setMaterialData([]);
      }

    } catch (err) {
      console.error("Error fetching fetchStockStatusList:", err.message);
    } finally {
      setLoading(false)
    }
  };

  const handleAccept = async (id) => {
  const token = getAuthToken();
  if (!token) return;
  try {
    await axios.post(
      `${config.API}/manager/maintenancescheduleaccept/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    MySwal.fire({
      icon: "success",
      title: "Maintenance Accepted",
      timer: 1500,
      showConfirmButton: false,
    });

    fetchMaintenanceschedule(); 
  } catch (error) {
    console.error(error);
    MySwal.fire("Error", "Something went wrong!", "error");
  }
};
const handleReject = async (id) => {
  const token = getAuthToken();
  if (!token) return;

  try {
    await axios.post(
      `${config.API}/manager/maintenanceschedulereject/${id}`,
      {}, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    MySwal.fire({
      icon: "success",
      title: "Maintenance Rejected",
      timer: 1500,
      showConfirmButton: false,
    });

    fetchMaintenanceschedule(); 
  } catch (error) {
    console.error(error);
    MySwal.fire("Error", "Something went wrong!", "error");
  }
};
const confirmAction = (type, id) => {
  MySwal.fire({
    title: type === "accept" ? "Accept Maintenance?" : "Reject Maintenance?",
    text:
      type === "accept"
        ? "Are you sure you want to accept this maintenance?"
        : "Are you sure you want to reject this maintenance?",
    icon: type === "accept" ? "success" : "warning",
    customClass: { popup: "font_family" },
    showCancelButton: true,
    confirmButtonColor: type === "accept" ? "#198754" : "#dc3545",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Yes",
    cancelButtonText: "No",
  }).then((result) => {
    if (result.isConfirmed) {
      type === "accept" ? handleAccept(id) : handleReject(id);
    }
  });
};
  return (
    <div className='container-fluid mt-4'>
      <div className='row g-4 align-items-stretch'>
        <div className="col-lg-6 d-flex" style={{ maxHeight: "630px", overflowY: "auto" }}>
          <div className="card flex-fill shadow-sm h-100 p-3 font_family">
            <div className="d-flex justify-content-between align-items-center">
              <strong className="mb-0 fs-4">Machine Status & Allocation</strong>
            </div>
            {loading ? (
              <Loader />
            ) : (
              <div className="table-responsive mt-4">
                <table className="table align-middle mb-0">
                  <thead className="table-light">
                    <tr className='position-sticky top-0'>
                      <th>MACHINE</th>
                      <th>TYPE</th>
                      <th>STATUS</th>
                      <th>UTILIZATION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {machineallocation?.machines && machineallocation.machines.length > 0 ? (
                      machineallocation.machines.map((machine, idx) => (
                        <tr key={idx} className="align-middle border-top">
                          <td
                            className="fw-semibold py-4"
                            onClick={() => {
                              setShowModal(true);
                              setMachineSetupId(machine.id);
                            }}

                            style={{ cursor: "pointer" }}
                          >
                            {machine?.machine_code || "-"}
                          </td>
                          <td>{machine?.type || "-"}</td>
                          <td>{getStatusBadge(machine?.status)}</td>
                          <td style={{ minWidth: "170px" }}>
                            <div className="d-flex align-items-center gap-2">
                              <div className="progress flex-grow-1" style={{ height: "10px" }}>
                                <div
                                  className="progress-bar bg-dark"
                                  style={{ width: `${machine?.utilization_percentage || 100}%` }}
                                ></div>
                              </div>
                              <small className="text-nowrap">
                                {machine?.utilization_percentage || 100}%
                              </small>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (

                      <tr>
                        <td colSpan="4" className="text-center text-muted py-4">
                          <strong>No Data Found</strong>
                        </td>
                      </tr>
                    )}
                  </tbody>

                </table>
              </div>
            )}
          </div>
        </div>

        <div className='col-lg-6'>
          <div className="card shadow-sm border-0 p-3 h-100">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <strong className="mb-0 d-flex align-items-center gap-2 fs-4">
                <BsWrench /> Maintenance Schedule
              </strong>
              <button className="btn btn-dark btn-sm" onClick={() => setShow(true)}>Schedule Maintenance</button>
            </div>

            <div className="table-responsive">
              <table className="table table-borderless align-middle">
                <thead className="table-light">
                  <tr>
                    <th>MACHINE</th>
                    <th>DATE</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>

                {loading ? (
                  <tbody>
                    <tr>
                      <td colSpan="4" className="text-center py-4">
                        <Loader />
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    {maintenancescheduleList?.maintenanceschedule &&
                      maintenancescheduleList.maintenanceschedule.length > 0 ? (
                      maintenancescheduleList.maintenanceschedule.map((schedule, index) => {
                        const status = schedule?.status?.toLowerCase();

                        return (
                          <tr key={index}>
                            {/* Machine Code */}
                            <td
                              onClick={() => {
                                setMachineMaintenance(true);
                                setSelectedMaintenanceId(schedule.id);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              {schedule?.machine?.machine_code}
                            </td>
                            <td>{formatDate(schedule?.maintenance_date)}</td>
                            <td>
                              <span
                                className={`badge p-2 ${status === "running" || status === "scheduled"
                                    ? "bg-success-subtle text-success"
                                    : status === "pending"
                                      ? "bg-warning-subtle text-warning"
                                      : "bg-danger-subtle text-danger"
                                  }`}
                              >
                                {schedule?.status}
                              </span>
                            </td>
                            <td>
                              {status === "pending" && (
                                <div className="d-flex gap-2">
                                  <button
                                    className="btn btn-success btn-sm px-2 py-1"
                                    onClick={() => confirmAction("accept", schedule.id)}
                                  >
                                    Accept
                                  </button>

                                  <button
                                    className="btn btn-danger btn-sm px-2 py-1"
                                    onClick={() => confirmAction("reject", schedule.id)}
                                  >
                                    Reject
                                  </button>
                                </div>
                              )}

                              {(status === "scheduled" || status === "running") && (
                                <BsCheck className="text-success fs-4" />
                              )}

                              {status === "rejected" && (
                                <BsX className="text-danger fs-4" />
                              )}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center text-muted py-4">
                          <strong>No Data Found</strong>
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className='row g-4 align-items-stretch mt-3'>
        <div className="col-lg-6">
          <div className="card shadow-sm border-0 p-3 h-100">
            <strong className="mb-3 fs-4 fw-semibold">Product Stock</strong>
            <div className="table-responsive">
              <table className="table align-middle">
                <thead className="table-light">
                  <tr>
                    <th>Product ID</th>
                    <th>Product Name</th>
                    <th>Product Quantity</th>
                    <th>Date of Update</th>
                    <th>View Details</th>
                  </tr>
                </thead>
                {
                  loading ? (
                    <Loader />
                  ) : (
                    <tbody>
                      {productstock?.products && productstock.products.length > 0 ? (
                        productstock.products.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.product?.product_code}</td>
                            <td>{item?.product?.name}</td>
                            <td>{item?.total_qty}</td>
                            <td>{formatDate(item?.product?.updated_at)}</td>
                            <td>
                              <button
                                className="btn btn-dark btn-sm p-1 text-decoration-none"
                                style={{ whiteSpace: "nowrap", cursor: "pointer" }}
                                onClick={() => {
                                  setProductId(item?.product_id);
                                  setProductStock(true);
                                }}
                              >
                                View Full Log
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center text-muted py-4">
                            <strong>No Data Found</strong>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )
                }
              </table>
            </div>
          </div>
        </div>
        <div className='col-lg-6'>
          <div className="card shadow-sm border-0 p-3 h-100">
            <strong className="mb-3 fs-4 fw-semibold">Material Status</strong>
            <ul className="list-unstyled mb-0 mt-2">
              {loading ? (
                <Loader />
              ) : (
                <>
                  {materialData && materialData?.length > 0 ? (
                    <ul className="list-group list-group-flush">
                      {materialData.map((item, index) => {
                        const available = Number(item?.available_quantity);
                        const required = Number(item?.required_quantity);
                        const minimum = Number(item?.minimum_quantity);

                        let status = "Good";
                        let badgeClass = "bg-success-subtle text-dark";

                        if (available < minimum) {
                          status = "Critical";
                          badgeClass = "bg-danger-subtle text-dark";
                        } else if (available < required) {
                          status = "Low";
                          badgeClass = "bg-warning-subtle text-dark";
                        }
                        return (
                          <li
                            key={index}
                            className="list-group-item d-flex justify-content-between border-0"
                          >
                            {item?.material?.material_name}
                            <span className={`badge ${badgeClass} p-2`}>
                              {status} ({available} {item?.material?.unit_of_measurement})
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                  )
                    : (
                      <div className="p-3 text-center text-muted">
                        No data record found
                      </div>
                    )}
                </>
              )}
            </ul>
          </div>
        </div>
      </div>
   
      {/* <button onClick={() => setImprovementActionWindow(true)} className='btn btn-dark mt-3'>Improvement Action</button><br />
      <button onClick={() => setMachineSetup(true)} className='btn btn-dark mt-3'>Machine Setup</button><br /> */}

      {/* ProductStockModal */}
      <ProductStockModal
        show={productStock}
        productId={productId}
        handleClose={() => setProductStock(false)}
      />
      {/* ImprovementActionWindowModal */}
      <ImprovementActionWindowModal
        show={improvementActionWindow}
        handleClose={() => setImprovementActionWindow(false)}
      />
      {/* MachineSetupModal */}
      <MachineSetupModal
        show={machineSetup}
        machineSetupId={machineSetupId}
        handleClose={() => setMachineSetup(false)}
      />

      {/*  Machine Modal */}
      <MaintenancescheduleModal
        show={show}
        onNewMaintenance={fetchMaintenanceschedule}
        handleClose={() => setShow(false)}
      />
      {/* MachineMaintenanceModal */}
      <MachineMaintenanceModal
        maintenanceId={selectedMaintenanceId}
        show={machineMaintenance}
        handleClose={() => setMachineMaintenance(false)}
      />
      <IndividualMachineStatusModal
        show={showModal}
        machineIds={machineSetupId}
        handleClose={() => setShowModal(false)}
      />
    </div>
  )
}
